import React from "react";
import PropTypes from "prop-types";
import { androidDownloadUrl, iosDownloadUrl } from "routes/routePaths";
import { Modal, Typography, Loader } from "components";
import { IoMdClose } from "react-icons/io";
import pmLogo from "assets/images/pocketmoni-logo.png";
import registerSuccess from "assets/images/register-success.jpeg";
import dowloandPmImg from "assets/images/pm-modal-download.png";
import androidImg from "assets/images/google-play-btn.png";
import iosImg from "assets/images/app-store-btn.png";
import circularPattern from "assets/images/pm-modal-download-bg.png";

import "./style.scss";

const RegistrationModal = ({
  showModal,
  self = true,
  adminUser = false,
  adminUserMessage,
  onClose,
  modalContentMapper,
  validationText,
  headerText,
  bodyText,
  onClick,
}) => {
  const pmInstructions = [
    "Download the PocketMoni App",
    "Become a registered Pocketmoni User",
    "Register to become an Agent here",
  ];

  const registrationComplete = () => (
    <div className="my-4" onClick={onClick}>
      <div className="d-flex justify-content-between">
        <img src={pmLogo} width="100" alt="" />
        <IoMdClose className="cursor-pointer" onClick={onClose} />
      </div>
      <div className="text-center mt-2 mx-auto" style={{ width: "90%" }}>
        <img src={registerSuccess} alt="" width="160" />
        <div>
          <Typography
            variant="subtitle1"
            component="h5"
            state="primary"
            className="mt-4"
          >
            {headerText ||
              (self
                ? "Please check your mailbox!"
                : "Registration Successful!")}
          </Typography>
          <Typography variant="body3" state="primary" className="my-4">
            {bodyText ||
              (adminUser
                ? adminUserMessage
                  ? adminUserMessage
                  : "A URL will be sent to the admin's mailbox and will be given further instructions on how to activate his/her account"
                : self
                ? "An email has been sent to your mailbox, please follow the instructions to activate your account."
                : "An email has been sent to the agent's mailbox. He/she will be given further instructions on how to activate his/her account.")}
          </Typography>
        </div>
      </div>
    </div>
  );

  const inValidPmNumber = () => (
    <div className="mt-3">
      <div className="mb-4">
        <div className="d-flex justify-content-end cursor-pointer">
          <div className="bg-neutral px-1" onClick={onClose}>
            <IoMdClose />
          </div>
        </div>
        <Typography variant="body2" state="danger" className="text-center">
          PocketMoni Number doesn't exist! You can register today
        </Typography>
      </div>

      <div className="row m-0">
        <div
          className="d-none d-md-block col-md-6 p-0"
          style={{ marginLeft: "-.06rem" }}
        >
          <img src={dowloandPmImg} width="280" alt="" />
          <img src={circularPattern} height="120" width="100" alt="" />
        </div>

        <div className="col-12 col-md-6 p-0 reg-pm-instructions">
          <Typography state="primary" variant="heading3">
            Quick Registration
          </Typography>
          <ul className="pm-list">
            <li>
              <Typography variant="caption1" state="grey">
                Dial *389# for instant registration. Alternatively, send SMS to
                20220 using this format: Reg 'Space' first name 'space' last name
              </Typography>
            </li>
            <li>
              <Typography variant="caption1" state="grey">
                Then register to Become an Agent here
              </Typography>
            </li>
          </ul>
          <Typography
            component="h6"
            variant="body2"
            className={"mt-4"}
            state="primary"
          >
            OR Download Our Mobile APP!
          </Typography>

          <ul className="pm-list">
            {pmInstructions.map((pmInstruction, key) => (
              <li key={key}>
                <Typography variant="caption1" state="grey">
                  {pmInstruction}
                </Typography>
              </li>
            ))}
          </ul>
          <div className="mt-2 d-flex justify-content-between">
            <a
              href={androidDownloadUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={androidImg} alt="pocketMoni" width="100" />
            </a>
            <a href={iosDownloadUrl} target="_blank" rel="noopener noreferrer">
              <img src={iosImg} alt="pocketMoni" width="100" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  const bvnValidating = () => (
    <>
      <div className="logo-container d-flex align-items-center justify-content-center">
        <img src={pmLogo} width="100" alt="" />
      </div>
      <div className="text-center px-2 register-validating-container">
        <Loader />
        <Typography variant="subtitle4" state="primary" className="mt-4">
          Validating {validationText}...Please wait
        </Typography>
      </div>
    </>
  );

  const getModalContent = () => {
    switch (modalContentMapper) {
      case "registrationComplete":
        return registrationComplete();

      case "invalidPmNumber":
        return inValidPmNumber();

      case "validating":
        return bvnValidating();

      default:
        break;
    }
  };

  const getCustomPadding = () =>
    modalContentMapper === "invalidPmNumber"
      ? "pr-4"
      : modalContentMapper === "validating"
      ? "p-0"
      : "px-4";

  return (
    <Modal
      showModal={showModal}
      customPadding={getCustomPadding()}
      onClose={onClose}
    >
      {getModalContent()}
    </Modal>
  );
};

RegistrationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  self: PropTypes.bool,
  onClose: PropTypes.func,
  modalContentMapper: PropTypes.string,
  adminUser: PropTypes.bool,
  headerText: PropTypes.string,
  bodyText: PropTypes.string,
  onClick: PropTypes.func,
};

export default RegistrationModal;
